import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchCostTypes() {
    const res = await apiFetch(`${API_URL}/api/CostType/GetCostTypes`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch cost types');
    return res.json();
}

export async function fetchCostTypesAdmin() {
    const res = await apiFetch(`${API_URL}/api/CostType/AdminList`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch cost types');
    return res.json();
}

export async function createCostType(name) {
    const res = await apiFetch(`${API_URL}/api/CostType/Create`, {
        method: 'POST',
        body: JSON.stringify({ name }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to create cost type');
    return res.json();
}

export async function updateCostType(id, name) {
    const res = await apiFetch(`${API_URL}/api/CostType/Update/${id}`, {
        method: 'POST',
        body: JSON.stringify({ name }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to update cost type');
    return res.json();
}

export async function toggleCostTypeActive(id) {
    const res = await apiFetch(`${API_URL}/api/CostType/ToggleActive/${id}`, { method: 'POST' });
    if (!res.ok) throw await httpError(res, 'Failed to toggle cost type');
}

export async function reorderCostTypes(orderedIds) {
    const res = await apiFetch(`${API_URL}/api/CostType/Reorder`, {
        method: 'POST',
        body: JSON.stringify(orderedIds),
    });
    if (!res.ok) throw await httpError(res, 'Failed to reorder cost types');
}
